import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import {
  ButtonBase,
  PickerSelectSimple,
  PickerCheckboxSimple,
  ThemeProvider,
  theme,
} from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";
import {
  payloadToUrl,
  urlToPayload,
  getReservePrices,
  getSortOptions,
  getFilterOptions,
  getAllProperties,
  Context,
  getSearchResults,
} from "services";
import { useRouter } from "next/router";
import ReactSlider from "react-slider";
import SearchSvg2 from "../../Icons/SearchSvg2";
// import { RangeSlider } from "@adobe/react-spectrum";
import SliderComponent from "./SliderComponent";
import { getSearchPayload } from "services";
import ResetIcon from "../../Icons/ResetIcon";
import RangeSearch from "./RangeSearch";

// import RadioButtonList from "./RadioButtonList";
import RangeDateSearch from "./RangeDateSearch";
import Dropdown from "./Dropdown";
import { twMerge } from "tailwind-merge";
import StateDropdown from "./Dropdown";

export default function SideBarSearch(props: any) {
  const { urlData, propertiesFacetsWithoutFilter } = props;
  const router = useRouter();
  const [filterObject, setFilterObject] = useState<any>();
  const [propertiesFacets, setPropertiesFacets] = useState<any>([]);
  const [ready, setReady] = useState<boolean>(true);
  const [refreshAssetList, setRefreshAssetList] = useState<any>();
  const [refreshSubAssetList, setRefreshSubAssetList] = useState<any>();
  const [refreshStateList, setRefreshStateList] = useState<any>();
  const [refreshCityList, setRefreshCityList] = useState<any>();
  const [refreshBankList, setRefreshBankList] = useState<any>();
  const [facetObject, setFacetObject] = useState();
  const { searchForm }: any = useContext(Context);
  const [reservePriceValue, setReservePriceValue] = useState<string | null>(
    null
  );
  const [dateRangeValue, setDateRangeValue] = useState<string | null>(null);

  // const rangeSearchRef = useRef<RangeSearchRef>(null);
  // const rangeDateSearchRef = useRef<RangeDateSearchRef>(null);

  const handleSearch = () => {
    if (reservePriceValue && reservePriceValue !== "0-0") {
      // console.log("reserve price value >>>>>>>>>> ", reservePriceValue)
      searchForm.setField("reserve_price", reservePriceValue);
    }

    // const dateRangeValue = rangeDateSearchRef.current?.getSearchValue();
    if (dateRangeValue) {
      searchForm.setField("auction_start_date_unix_timestamp", dateRangeValue);
    }

    payloadToUrl(router, searchForm.value);
  };

  useEffect(() => {
    handleRefreshElement();
  }, [propertiesFacets, searchForm.value]);

  useEffect(() => {
    if (props.filterSearchResult !== undefined) {
      handleGetPropertiesResults();
    }
  }, [props.filterSearchResult]);

  useEffect(() => {
    setReady(false);
    setReady(true);
  }, []);

  const handleGenerateFacets = (currentFilterPayloadList: any) => {
    const facetObject: any = {};
    const bank: any = [];
    const state: any = [];
    const city: any = [];
    const asset: any = [];
    const sub_asset_type: any = [];
    if (currentFilterPayloadList) {
      currentFilterPayloadList?.map((currentFilterPayload: any, index: any) => {
        currentFilterPayload?.facet_counts?.map((value: any) => {
          const countValuesList = value.counts;
          const fieldName = value.field_name;

          switch (fieldName) {
            case "dump.bank.bank_name":
            case "dump.bank.bank_slug":
              countValuesList.map((value: any) => {
                const currentBankObject = {
                  name: value.parent.bank_name,
                  uuid: value.parent.bank_uuid,
                  slug: value.parent.bank_slug,
                };
                const isBankObjectPreset = bank.find(
                  (bankObject: any) =>
                    bankObject.uuid === currentBankObject.uuid
                );
                if (isBankObjectPreset === undefined)
                  bank.push(currentBankObject);
              });

              break;

            case "dump.location.state_name":
            case "dump.location.state_slug":
              if (index !== 0) {
                countValuesList.map((value: any) => {
                  const currentStateObject = {
                    name: value.parent.state_name,
                    uuid: value.parent.state_uuid,
                    slug: value.parent.state_slug,
                  };
                  const isStateObjectPreset = state.find((stateObject: any) => {
                    return stateObject.uuid === currentStateObject.uuid;
                  });
                  if (isStateObjectPreset === undefined)
                    state.push(currentStateObject);
                });
              }
              break;

            case "dump.location.city_name":
            case "dump.location.city_slug":
              if (index !== 0) {
                countValuesList.map((value: any) => {
                  const currentCityObject = {
                    name: value.parent.city_name,
                    uuid: value.parent.city_uuid,
                    slug: value.parent.city_slug,
                  };
                  const isCityObjectPreset = city.find(
                    (cityObject: any) =>
                      cityObject.uuid === currentCityObject.uuid
                  );
                  if (isCityObjectPreset === undefined)
                    city.push(currentCityObject);
                });
              }
              break;
            case "dump.asset.asset_type_name":
            case "dump.asset.asset_type_slug":
              if (index !== 0) {
                countValuesList.map((value: any) => {
                  const currentAssetObject = {
                    uuid: value.parent.asset_type_uuid,
                    name: value.parent.asset_type_name,
                    slug: value.parent.asset_type_slug,
                  };
                  const isAssetObjectPresent = asset.find(
                    (assetObject: any) => {
                      return assetObject.uuid === currentAssetObject.uuid;
                    }
                  );
                  if (isAssetObjectPresent === undefined) {
                    asset.push(currentAssetObject);
                  }
                  const currentSubAssetObject = {
                    uuid: value.parent.sub_asset_type_uuid,
                    name: value.parent.sub_asset_type_name,
                    slug: value.parent.sub_asset_type_slug,
                  };
                  const isSubAssetObjectPresent = sub_asset_type.find(
                    (subAssetObject: any) => {
                      return subAssetObject.uuid === currentSubAssetObject.uuid;
                    }
                  );
                  if (isSubAssetObjectPresent === undefined) {
                    sub_asset_type.push(currentSubAssetObject);
                  }
                });
              }
              break;
            case "dump.asset.sub_asset_type_name":
            case "dump.asset.sub_asset_type_slug":
              if (index !== 0) {
                countValuesList.map((value: any) => {
                  const currentSubAssetsObject: any = {
                    uuid: value.parent.sub_asset_type_uuid,
                    name: value.parent.sub_asset_type_name,
                    slug: value.parent.sub_asset_type_slug,
                  };
                  const isSubAssetsObjectPresent = sub_asset_type.find(
                    (subAssetObject: any) => {
                      return (
                        subAssetObject.uuid === currentSubAssetsObject.uuid
                      );
                    }
                  );
                  if (isSubAssetsObjectPresent === undefined) {
                    sub_asset_type.push(currentSubAssetsObject);
                  }
                });
              }
              break;
            default:
              break;
          }
        });
        facetObject.bank = bank;
        facetObject.state = state;
        facetObject.city = city;
        facetObject.asset = asset;
        facetObject.sub_asset_type = sub_asset_type;
      });
    }

    return facetObject;
  };
  const handleGetPropertiesResults = async () => {
    const facetObject = handleGenerateFacets(
      props?.filterSearchResult?.results
    );
    setPropertiesFacets(facetObject);
  };

  const generateDropdownValues = async (formElement: any, query: any) => {
    let filteredData;
    switch (formElement) {
      case "asset_type":
        filteredData = propertiesFacets?.asset?.map((item: any) => {
          return { value: item.slug, label: item.name };
        });
        // console.log("Generated dropdown values for asset_type:", filteredData);
        break;
      case "sub_asset_type":
        filteredData = propertiesFacets?.sub_asset_type?.map((item: any) => {
          return { value: item.slug, label: item.name };
        });

        break;
      case "state":
        filteredData = propertiesFacets?.state?.map((item: any) => {
          return { value: item.slug, label: item.name };
        });

        break;
      case "city":
        filteredData = propertiesFacets?.city?.map((item: any) => {
          return { value: item.slug, label: item.name };
        });

        break;
      case "institutes":
        filteredData = propertiesFacets?.bank?.map((item: any) => {
          return { value: item.slug, label: item.name };
        });
        break;
      default:
        break;
    }

    if (query) {
      const filterOptions = filteredData?.filter(
        (option: any) =>
          option.label.toLowerCase().indexOf(query.toLowerCase()) > -1
      );

      return filterOptions;
    } else {
      return filteredData;
    }
  };

  const handleBankOnChange = async (value: any) => {
    searchForm.setField("institutes", value);
    payloadToUrl(router, searchForm.value);
  };
  const handleAssetOnChange = async (value: any) => {
    // console.log("Selected value in handleAssetOnChange:", value);
    searchForm.setField("asset_type", value);
    searchForm.setField("sub_asset_type", "");
    payloadToUrl(router, searchForm.value);
  };

  const handleSubAssetOnChange = (value: any) => {
    searchForm.setField("sub_asset_type", value);
    payloadToUrl(router, searchForm.value);
  };

  const handleStateOnChange = (value: any) => {
    // console.log("value in state change : ", value)
    searchForm.setField("state", value);
    searchForm.setField("city", "");
    payloadToUrl(router, searchForm.value);
  };

  const handleCityOnChange = (value: any) => {
    searchForm.setField("city", value);
    payloadToUrl(router, searchForm.value);
  };

  const handleRefreshElement = () => {
    setRefreshAssetList(new Date().getTime());
    setRefreshSubAssetList(new Date().getTime());
    setRefreshStateList(new Date().getTime());
    setRefreshCityList(new Date().getTime());
    setRefreshBankList(new Date().getTime());
  };

  useEffect(() => {
    setRefreshAssetList(new Date().getTime());
    setRefreshCityList(new Date().getTime());
    setRefreshBankList(new Date().getTime());
  }, [searchForm.value.state && propertiesFacets]);

  const handleSubmit = () => {
    payloadToUrl(router, searchForm.value);
  };

  const newTheme = {
    ...theme,
    variants: {},
  };

  return (
    <ThemeProvider value={newTheme}>
      <div
        className="relative shadow-sm border-r flex flex-col  h-full overflow-auto"
        // style={{ scrollbarWidth: "none" }}
      >
        <div className="flex-1 flex flex-col">
          <div className="flex justify-between bg-gray-50 items-center px-8 py-3 border-b text-lg text-gray-900 font-medium">
            <div>Advance Search</div>
          </div>
          {ready ? (
            <>
              <div className="py-4 px-8 border-b-2 flex flex-col gap-y-1">
                <div>
                  <Dropdown
                    refresh={refreshStateList}
                    dataSource={async (c: any) => {
                      return generateDropdownValues("state", c);
                    }}
                    defaultString="Select state"
                    field={"state"}
                    searchFormField={searchForm.getField("state")}
                    labelBaseProps={{
                      label: "State",
                      labelBaseClasses: {
                        font: "text-xs font-medium leading-6 ",
                      },
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses:
                          "font-normal text-xs text-gray-400 ",
                        spanBaseClasses: "text-xs font-normal leading-2 ",
                      },
                      optionClasses: {
                        label: "text-small bg-blue-200",
                      },
                    }}
                    onChange={(value: any) => handleStateOnChange(value)}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={true}
                    disabled={false}
                  />
                  {/* <PickerSelectSimple
                    refresh={refreshStateList}
                    dataSource={async (c) => {
                      return generateDropdownValues("state", c);
                    }}
                    defaultString="Select state"
                    defaultSelected={
                      searchForm.getField("state") !== ""
                        ? [searchForm.getField("state")]
                        : []
                    }
                    labelBaseProps={{
                      label: "State",
                      labelBaseClasses: {
                        font: "text-xs font-medium leading-6 ",
                      },
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses: "font-normal text-xs text-gray-400 ",
                        spanBaseClasses: "text-xs font-normal leading-2 ",
                      },
                      optionClasses: {
                        label: "text-small bg-blue-200",
                      },
                    }}
                    onChange={(value: any) => handleStateOnChange(value)}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={true}
                    disabled={false}
                  /> */}
                </div>
                <div>
                  <Dropdown
                    refresh={refreshCityList}
                    dataSource={async (c: any) => {
                      return generateDropdownValues("city", c);
                    }}
                    defaultString="Select city"
                    field={"city"}
                    searchFormField={searchForm.getField("city")}
                    defaultSelected={
                      searchForm.getField("city") !== ""
                        ? [searchForm.getField("city")]
                        : []
                    }
                    labelBaseProps={{
                      label: "City",
                      labelBaseClasses: {
                        font: "text-xs font-medium leading-6 ",
                      },
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses: "font-normal text-xs text-gray-400",
                        spanBaseClasses: "text-xs font-normal leading-2",
                      },
                      optionClasses: {
                        label: "text-small bg-blue-200",
                      },
                    }}
                    onChange={(value: any) => handleCityOnChange(value)}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={true}
                    disabled={searchForm.value.state ? false : true}
                  />
                  {/* <PickerSelectSimple
                    refresh={refreshCityList}
                    dataSource={async (c) => {
                      return generateDropdownValues("city", c);
                    }}
                    defaultString="Select city"
                    defaultSelected={
                      searchForm.getField("city") !== ""
                        ? [searchForm.getField("city")]
                        : []
                    }
                    labelBaseProps={{
                      label: "City",
                      labelBaseClasses: {
                        font: "text-xs font-medium leading-6 ",
                      },
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses: "font-normal text-xs text-gray-400",
                        spanBaseClasses: "text-xs font-normal leading-2",
                      },
                      optionClasses: {
                        label: "text-small bg-blue-200",
                      },
                    }}
                    onChange={(value: any) => handleCityOnChange(value)}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={true}
                    disabled={searchForm.value.state ? false : true}
                  /> */}
                </div>
                <div>
                  <Dropdown
                    refresh={refreshAssetList}
                    dataSource={async (c: any) => {
                      return generateDropdownValues("asset_type", c);
                    }}
                    defaultString="Select property type"
                    defaultSelected={
                      searchForm.getField("asset_type") !== ""
                        ? [searchForm.getField("asset_type")]
                        : []
                    }
                    labelBaseProps={{
                      label: "Property type",
                      labelBaseClasses: {
                        font: "text-xs font-medium leading-6 ",
                      },
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses: "font-normal text-xs text-gray-400",
                        spanBaseClasses: "text-xs font-normal leading-2",
                      },
                      optionClasses: {
                        label: "text-small bg-blue-200",
                      },
                    }}
                    onChange={(value: any) => handleAssetOnChange(value)}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={true}
                    disabled={false}
                    field={"asset_type"}
                    searchFormField={searchForm.getField("asset_type")}
                  />
                  {/* <PickerSelectSimple
                    refresh={refreshAssetList}
                    dataSource={async (c) => {
                      return generateDropdownValues("asset_type", c);
                    }}
                    defaultString="Select property type"
                    defaultSelected={
                      searchForm.getField("asset_type") !== ""
                        ? [searchForm.getField("asset_type")]
                        : []
                    }
                    labelBaseProps={{
                      label: "Property type",
                      labelBaseClasses: {
                        font: "text-xs font-medium leading-6 ",
                      },
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses: "font-normal text-xs text-gray-400 h-10",
                        spanBaseClasses: "text-xs font-normal leading-2",
                      },
                      optionClasses: {
                        label: "text-small bg-blue-200",
                      },
                    }}
                    onChange={(value: any) => handleAssetOnChange(value)}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={true}
                    disabled={false}
                  /> */}
                </div>
                <div>
                  <Dropdown
                    refresh={refreshSubAssetList}
                    dataSource={async (c: any) => {
                      return generateDropdownValues("sub_asset_type", c);
                    }}
                    field={"sub_asset_type"}
                    searchFormField={searchForm.getField("sub_asset_type")}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses:
                          "font-normal text-xs text-gray-400 truncate pr-6",
                        spanBaseClasses:
                          "text-xs font-normal leading-2 truncate",
                      },
                      optionClasses: {
                        label: "text-small bg-blue-200",
                      },
                    }}
                    defaultString="Select property sub type"
                    defaultSelected={
                      searchForm.getField("sub_asset_type") !== ""
                        ? [searchForm.getField("sub_asset_type")]
                        : []
                    }
                    labelBaseProps={{
                      label: "Property sub type",
                      labelBaseClasses: {
                        font: "text-xs font-medium leading-6 ",
                      },
                    }}
                    onChange={(value: any) => handleSubAssetOnChange(value)}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={true}
                    disabled={searchForm.value.asset_type ? false : true}
                  />
                  {/* <PickerSelectSimple
                    refresh={refreshSubAssetList}
                    dataSource={async (c) => {
                      return generateDropdownValues("sub_asset_type", c);
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses: "font-normal text-xs text-gray-400 truncate pr-6",
                        spanBaseClasses: "text-xs font-normal leading-2 truncate",
                      },
                      optionClasses: {
                        label: "text-small bg-blue-200",
                      },
                    }}
                    defaultString="Select property sub type"
                    defaultSelected={
                      searchForm.getField("sub_asset_type") !== ""
                        ? [searchForm.getField("sub_asset_type")]
                        : []
                    }
                    labelBaseProps={{
                      label: "Property sub type",
                      labelBaseClasses: {
                        font: "text-xs font-medium leading-6 ",
                      },
                    }}
                    onChange={(value: any) => handleSubAssetOnChange(value)}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={true}
                    disabled={searchForm.value.asset_type ? false : true}
                  /> */}
                </div>
                <div>
                  <Dropdown
                    field={"institutes"}
                    searchFormField={searchForm.getField("institutes")}
                    refresh={refreshBankList}
                    dataSource={async (c: any) => {
                      return generateDropdownValues("institutes", c);
                    }}
                    enableToggle
                    defaultString="Select Institutes"
                    defaultSelected={
                      searchForm.getField("institutes") !== ""
                        ? [searchForm.getField("institutes")]
                        : []
                    }
                    labelBaseProps={{
                      label: "Institutes",
                      labelBaseClasses: {
                        font: "text-xs font-medium leading-6 ",
                      },
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses: "font-normal text-xs text-gray-400",
                        spanBaseClasses: "text-xs font-normal leading-2",
                      },
                      optionClasses: {
                        label: "text-small bg-blue-200",
                      },
                    }}
                    onChange={(value: any) => {
                      handleBankOnChange(value);
                    }}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={false}
                    disabled={false}
                  />
                  {/* <PickerSelectSimple
                    refresh={refreshBankList}
                    dataSource={async (c) => {
                      return generateDropdownValues("institutes", c);
                    }}
                    enableToggle
                    defaultString="Select Institutes"
                    defaultSelected={
                      searchForm.getField("institutes") !== ""
                        ? [searchForm.getField("institutes")]
                        : []
                    }
                    labelBaseProps={{
                      label: "Institutes",
                      labelBaseClasses: {
                        font: "text-xs font-medium leading-6 ",
                      },
                    }}
                    pickerSelectSimpleClasses={{
                      selectedDataClasses: {
                        placeholderClasses: "font-normal text-xs text-gray-400",
                        spanBaseClasses: "text-xs font-normal leading-2",
                      },
                      optionClasses: {
                        label: "text-small bg-blue-200",
                      },
                    }}
                    onChange={(value: any) => {
                      handleBankOnChange(value);
                    }}
                    valueKey="value"
                    multiple={false}
                    enableClear={false}
                    enableClose={false}
                    enableSearch={false}
                    disabled={false}
                  /> */}
                </div>

                <div className="py-1">
                  {/* <div className="flex flex-col">
                  <div className="text-sm font-medium">Select Date Range</div>
                  
                </div> */}

                  <div className="overflow-hidden">
                    <RangeDateSearch onValueChange={setDateRangeValue} />
                  </div>
                </div>

                <div className="py-1">
                  {/* <div className="flex flex-col">
                  <div className="text-sm font-medium">Select Price Range</div>
                  
                </div> */}

                  <div className="overflow-hidden">
                    {/* <SliderComponent /> */}
                    <RangeSearch onValueChange={setReservePriceValue} />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="flex max-w-2xl h-full flex-col py-4 justify-center items-center">
              <div className="flex justify-between items-center">
                <div className="animate-pulse w-64 px-4">
                  <div className="bg-gray-400 animate-pulse h-4 w-1/4 mb-2"></div>
                  <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
                </div>
                <div className="animate-pulse w-64 px-4">
                  <div className="bg-gray-400 animate-pulse h-4 w-1/4 mb-2"></div>
                  <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <div className="animate-pulse w-64 px-4">
                  <div className="bg-gray-400 animate-pulse h-4 w-1/4 mb-2"></div>
                  <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
                </div>
                <div className="animate-pulse w-64 px-4">
                  <div className="bg-gray-400 animate-pulse h-4 w-1/4 mb-2"></div>
                  <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
                </div>
              </div>
            </div>
          )}

          <div className="p-4 mt-auto flex">
            <ButtonBase
              variant="primary"
              type="submit"
              label="Search Properties"
              onClick={() => handleSearch()}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                width: "w-full",
                padding: "px-4 py-3",
              }}
              buttonPrefix={<SearchSvg2 />}
            />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
